import i18n from "~/i18n";
import { TimeMode } from "~/models/mode.model";

export const AvoltaTimeMode: TimeMode[] = [
    {
        label: i18n.global.t('time.n-month', 1),
        name: 'month',
        timeUnit: 'month',
        time: 1,
        default: true,
    },
    {
        label: i18n.global.t('time.n-month', 6),
        name: '6month',
        timeUnit: 'month',
        time: 6,
        default: false,
    },
]